<script setup lang="ts">
import type { GetPrivacyPolicyQuery } from "~~/types/graphql";
import getPrivacyPolicy from "@/graphql/privacy-policy.query.graphql";
const { locale } = useI18n();
const { data, error } = await useAsyncQuery<GetPrivacyPolicyQuery>(
  getPrivacyPolicy,
  {
    locale: locale.value,
  },
);

if (error.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page not found",
    message: error.value?.message,
  });
}

const header = computed(() => {
  return data.value?.privacyPolicy?.data?.attributes?.header;
});
const footer = computed(() => {
  return data.value?.privacyPolicy?.data?.attributes?.footer;
});

const localization = useLocalization();
localization.value.de.pathMatch = [""];
localization.value.en.pathMatch = ["privacy-policy"];
setSeo(undefined, data.value.privacyPolicy?.data?.attributes.localizations);
</script>

<template>
  <main>
    <BlockHeaderDefault
      :headline="header?.headline"
      :subheadline="header?.subheadline"
    />
    <BlockRenderer
      v-for="(block, index) in data?.privacyPolicy?.data?.attributes
        ?.components"
      v-bind="block"
      :key="`${block?.__typename}-${index}`"
    />
    <block-footer :headline="footer?.Titel" :link="footer?.link" />
  </main>
</template>
